module["exports"] = [
  "town",
  "ton",
  "land",
  "ville",
  "berg",
  "burgh",
  "borough",
  "bury",
  "view",
  "port",
  "mouth",
  "stad",
  "furt",
  "chester",
  "mouth",
  "fort",
  "haven",
  "side",
  "shire"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/city_suffix.js
// module id = 528
// module chunks = 0